import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import "./index.css";
import App from "./App";

const posthogToken = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST;

if (!posthogToken || !posthogHost) {
  throw new Error("PostHog environment variables are required.");
}

posthog.init(posthogToken, {
  api_host: posthogHost,
  defaults: "2026-05-30",
  capture_pageview: "history_change",
  autocapture: false,
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
